import React, { useEffect, useState, useRef } from "react";

const CursorFollower = () => {
  const [position, setPosition] = useState({ x: -100, y: -100 });
  const [followerPosition, setFollowerPosition] = useState({ x: -100, y: -100 });
  const [isHovering, setIsHovering] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(true);
  const requestRef = useRef();

  useEffect(() => {
    // Check if mobile or touch device
    const checkDevice = () => {
      const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
      const isSmallScreen = window.innerWidth < 1024;
      setIsMobile(isTouchDevice || isSmallScreen);
    };
    
    checkDevice();
    window.addEventListener('resize', checkDevice);

    const handleMouseMove = (e) => {
      setPosition({ x: e.clientX, y: e.clientY });
      setIsVisible(true);
    };

    const handleMouseLeave = () => setIsVisible(false);
    const handleMouseEnter = () => setIsVisible(true);

    // Detect hover on interactive elements
    const handleElementHover = (e) => {
      const target = e.target;
      const isInteractive = 
        target.tagName === 'BUTTON' || 
        target.tagName === 'A' || 
        target.closest('button') || 
        target.closest('a') ||
        target.classList.contains('cursor-hover');
      setIsHovering(isInteractive);
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseover", handleElementHover);
    document.addEventListener("mouseleave", handleMouseLeave);
    document.addEventListener("mouseenter", handleMouseEnter);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseover", handleElementHover);
      document.removeEventListener("mouseleave", handleMouseLeave);
      document.removeEventListener("mouseenter", handleMouseEnter);
      window.removeEventListener('resize', checkDevice);
    };
  }, []);

  // Smooth follow animation
  useEffect(() => {
    if (isMobile) return;
    
    const animate = () => {
      setFollowerPosition(prev => ({
        x: prev.x + (position.x - prev.x) * 0.12,
        y: prev.y + (position.y - prev.y) * 0.12,
      }));
      requestRef.current = requestAnimationFrame(animate);
    };
    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
  }, [position, isMobile]);

  // Don't render on mobile/touch devices
  if (isMobile) {
    return null;
  }

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 9999,
      }}
    >
      {/* Outer circle - follows with delay */}
      <div
        style={{
          position: 'absolute',
          left: followerPosition.x,
          top: followerPosition.y,
          width: isHovering ? 50 : 32,
          height: isHovering ? 50 : 32,
          marginLeft: isHovering ? -25 : -16,
          marginTop: isHovering ? -25 : -16,
          borderRadius: '50%',
          border: `1.5px solid rgba(109, 180, 50, ${isHovering ? 0.8 : 0.4})`,
          backgroundColor: isHovering ? 'rgba(109, 180, 50, 0.1)' : 'transparent',
          opacity: isVisible ? 1 : 0,
          transition: 'width 0.3s ease, height 0.3s ease, margin 0.3s ease, border-color 0.3s ease, background-color 0.3s ease, opacity 0.3s ease',
          mixBlendMode: 'difference',
        }}
      />

      {/* Inner dot - follows cursor directly */}
      <div
        style={{
          position: 'absolute',
          left: position.x,
          top: position.y,
          width: 6,
          height: 6,
          marginLeft: -3,
          marginTop: -3,
          borderRadius: '50%',
          backgroundColor: '#6DB432',
          opacity: isVisible ? 1 : 0,
          transition: 'opacity 0.2s ease',
          boxShadow: '0 0 10px rgba(109, 180, 50, 0.5)',
        }}
      />
    </div>
  );
};

export default CursorFollower;
